import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 lg:py-24" data-id="element-46" data-mp="1bmlnvb30w3m2">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-10 px-6 lg:grid-cols-[0.7fr_1fr] lg:gap-16" data-id="element-47" data-mp="1gkn1vhlldcqo">
        <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-48" data-mp="24aheby200zae">
          Preguntas frecuentes
        </h2>

        <div className="divide-y divide-cream-deep border-y border-cream-deep" data-id="element-49" data-mp="1ujmsguso01ph">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-50" data-mp="2n824r9kew5x4" data-mpi={index}>
                <h3 data-id="element-51" data-mp="2n70tb3zhhhev">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunset" data-id="element-52" data-mp="2n6hcxrphf12y">
                    <span className="font-display text-lg font-bold text-ink" data-id="element-53" data-mp="1emog0ivjil1u">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-sunset transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-54" data-mp="1oj9k91zqjs4m" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="1skmrngih83dn">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="35omxl1dc26r">
                      <p className="max-w-2xl pb-5 pr-10 text-base leading-relaxed text-ink-soft" data-id="element-57" data-mp="286hn5l9xk2nv">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}